export enum PortfolioType {
  BIO = 'bio',
  CAREER_GOAL = 'career_goal',
  INTEREST = 'interest'
}

export interface PortfolioResponse {
  id: string
  type: PortfolioType
  content: string
  createdAt: string
  updatedAt: string
  userId: string
}

export interface PortfolioByTypeResponse {
  bio?: PortfolioResponse
  careerGoals: {
    data: PortfolioResponse[]
    total: number
  }
  interests: {
    data: PortfolioResponse[]
    total: number
  }
}

export interface CreatePortfolioDto {
  type: PortfolioType
  content: string
}

export interface UpdatePortfolioDto {
  type?: PortfolioType
  content?: string
}
